import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import styles from './FacebookLike.module.scss';
import facebookShareConfig from './facebook.json';

function FacebookLikeComponent(props) {
    const translator = useTranslator();
    const { title, href } = props;
    const { likeDialog } = facebookShareConfig;
    const iframeTitle = title || likeDialog.title;
    const iframeHref = encodeURIComponent(href || likeDialog.href);
    const src = likeDialog.src.replace(likeDialog.hrefPlaceholder, iframeHref);

    return (
        <iframe
            title={translator(iframeTitle)}
            frameBorder="0"
            allowTransparency
            className={styles.facebookLike}
            width="100%"
            height="80"
            src={src}
        />
    );
}

FacebookLikeComponent.propTypes = {
    title: PropTypes.string,
    href: PropTypes.string
};

FacebookLikeComponent.defaultProps = {
    title: undefined,
    href: undefined
};

export default FacebookLikeComponent;
